module.exports = __webpack_public_path__ + "media/application/images/svgs/home-99fa7e1829332bb7e93afe8cd6879c8a.svg";